import { render, staticRenderFns } from "./VehicleChoice.vue?vue&type=template&id=dbd5fd54&scoped=true&"
import script from "./VehicleChoice.vue?vue&type=script&lang=js&"
export * from "./VehicleChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd5fd54",
  null
  
)

export default component.exports